import styled from 'styled-components'

export const TableContainer = styled.div<{ $hasCustomWidths?: boolean }>`
  width: 100%;
  display: flex;
  flex-direction: column;
  height: 100%;

  ${({ $hasCustomWidths }) =>
    $hasCustomWidths &&
    `
    .ant-table-header table,
    .ant-table-body table {
      table-layout: fixed !important;
    }
  `}

  .sticky-footer .ant-table-content::-webkit-scrollbar,
  .sticky-footer .ant-table-body::-webkit-scrollbar {
    display: none;
  }

  .sticky-footer .ant-table-content::-webkit-scrollbar-track,
  .sticky-footer .ant-table-body::-webkit-scrollbar-track {
    display: none;
  }

  .sticky-footer .ant-table-content,
  .sticky-footer .ant-table-body {
    scrollbar-width: none;
    -ms-overflow-style: none;
  }

  .ant-table.ant-table-small .ant-table-tbody > tr > td:first-child {
    /*padding: 0;*/
  }

  .ant-table.ant-table-small .ant-table-tbody > tr > td {
    padding: 4px;
  }

  .ant-table.ant-table-bordered > .ant-table-container > .ant-table-body > table > tbody > tr > td {
    /*border-color: #0000000F;*/
  }

  .cell-content {
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
  }

  .sticky-footer .ant-table.ant-table-bordered > .ant-table-container > .ant-table-header > table > thead > tr > th {
    border-color: #0000000F;
  }

  /*.ant-table-wrapper .ant-table-column-title, th {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }*/
`
export const TableBody = styled.div`
  flex: 1;
`

export const TableScroller = styled.div<{ $scrollWidth?: number; hide?: boolean }>`
  position: sticky;
  z-index: 1002;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 20px;
  overflow: auto hidden;
  background: rgb(240, 240, 240);
  border-top: 1px solid rgb(221, 221, 221);
  margin-bottom: 10px;

  &:after {
    content: '';
    display: var(--scroll-display, block);
    height: 1px;
    width: ${({ $scrollWidth }) => ($scrollWidth ? `${$scrollWidth}px` : '100%')};
  }
`

export const TableCheckboxWrapper = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  cursor: pointer;
`

export const TotalsTableWrapper = styled.div`
  border-top: 1px solid #000;
  overflow: hidden;

  .ant-table-content {
    &::-webkit-scrollbar {
      display: none
    }

    -ms-overflow-style: none;
    scrollbar-width: none;
  }

  tr td {
    border-color: #000 !important;
  }
`

export const MobileCard = styled.div`
  padding: 12px 0;
  border-bottom: 1px solid #f0f0f0;
  background: #fff;

  &.table-row-new {
    background-color: #AFE4AF !important;

    &:hover {
      background-color: #C3EDC3 !important;
    }
  }

  &.table-row-expired {
    background-color: #F49191 !important;

    &:hover {
      background-color: #F7B8B8 !important;
    }
  }

  &.table-row-done {
    background-color: #B5DEFF !important;

    &:hover {
      background-color: #C9E7FF !important;
    }
  }
`

export const MobileCardHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
`

export const MobileCardTitle = styled.div`
  font-size: 12px;
  font-weight: 500;
`

export const MobileCardStage = styled.div`
  font-size: 14px;
`

export const MobileCardRow = styled.div`
  display: flex;
  gap: 8px;

  &:not(:last-child) {
    margin-bottom: 8px;
  }
`

export const MobileCardLabel = styled.div`
  color: #8c8c8c;
  font-size: 12px;

  .table-row-new &,
  .table-row-expired &,
  .table-row-done & {
    color: #000;
    font-weight: 600;
  }
`

export const MobileCardValue = styled.div`
  font-size: 12px;
`

export const MobileTableFooter = styled.div`
  position: relative;
  width: 100%;
  background-color: ${({ theme }) => theme.colors.white};
  border-top: 1px solid #f0f0f0;
  padding: 8px 0;

  .ant-pagination {
    .ant-pagination-item,
    .ant-pagination-prev,
    .ant-pagination-next {
      min-width: 44px;
      height: 44px;
      line-height: 42px;
      font-size: 16px;
      border-radius: 8px;
    }

    .ant-pagination-item a {
      line-height: 42px;
    }

    .ant-pagination-prev .ant-pagination-item-link,
    .ant-pagination-next .ant-pagination-item-link {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
      font-size: 18px;
    }

    .ant-pagination-options {
      .ant-select-selector {
        height: 44px;
        padding: 0 12px;
        font-size: 16px;

        .ant-select-selection-item {
          line-height: 42px;
        }
      }
    }
  }

  @media (max-width: 768px) {
    padding-bottom: 30px;
  }
`
